module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('planoConciliacao.titulos.planosConciliacao'),
      "subTitle": _vm.$t('planoConciliacao.titulos.visualizacao')
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('planoConciliacao.labels.novoPlano'),
      "id": "btnNovoPlanoDeConciliacao",
      "clickFunction": _vm.newPlan,
      "title": _vm.plans && _vm.plans.length > 0 ? _vm.$t('planoConciliacao.labels.cadastroPlanoBloquado') : _vm.$t('planoConciliacao.labels.cadastroPlano'),
      "disabled": _vm.plans && _vm.plans.length > 0
    },
    slot: "new-button"
  })], 1), _c('div', {
    attrs: {
      "id": "plans"
    }
  }, [(_vm.plans && _vm.plans.length > 0) ? _c('div', [_c('div', {
    staticClass: "plans-header"
  }, [_c('div', {
    staticClass: "col-xs-3 col-sm-3 col-md-3 col-lg-4 plans-header-column-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.nomePlano'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-3 col-lg-2 plans-header-column-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.ordem'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-3 col-lg-2 plans-header-column-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.relevancia'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-3 col-lg-2 plans-header-column-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.status'))
    }
  }), _c('div', {
    staticClass: "pull-right px-0 text-right col-xs-4 col-sm-2 col-md-2 col-lg-1"
  }, [_c('div', {
    staticClass: "plans-header-acoes-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.acoes'))
    }
  })])]), _vm._l((_vm.plans), function(plan) {
    return _c('div', [_c('vue-drag-tree', {
      staticClass: "vue-drag-tree",
      attrs: {
        "model": plan,
        "clickFunction": _vm.createEditPlan,
        "clickRemoveFunction": _vm.handleRemove,
        "showRemove": true,
        "father": plan,
        "id": plan.id,
        "buttonsTitle": _vm.treeViewButtonTitle,
        "current-highlight": false,
        "default-text": null,
        "hover-color": "lightblue"
      }
    }), _c('div', {
      staticClass: "clear"
    })], 1)
  })], 2) : _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.resultadoVazio'))
    }
  })])])], 1)]), _c('confirm-modal', {
    attrs: {
      "id": "confirmRemovePlan"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.confirmarDelete'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalRemoverPlan",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.sim'),
      "id": "btnConfirmarModalRemoverPlan",
      "clickFunction": _vm.removePlan
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-66984113", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66984113"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/conciliationPlan/list.pug
// module id = 1428
// module chunks = 0